import React from 'react';

import './portal-drawer.scss';

export default function PortalDrawer() {
    return <div id='PortalDrawer' className='portalDrawer' />;
}
